import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AppRole } from './api.types';

export interface AdminAccessRequestUser {
	id: string;
	email: string | null;
	name: string | null;
	role: AppRole;
	isApproved: boolean;
	approvalStatus: string;
	accessRequestedAt: string | null;
	accessRequestNote: string | null;
}

export interface AdminAccessRequestsListResponse {
	users: AdminAccessRequestUser[];
}

@Injectable({ providedIn: 'root' })
export class AdminAccessRequestsService {
	constructor(private readonly http: HttpClient) {}

	list(): Observable<AdminAccessRequestsListResponse> {
		return this.http.get<AdminAccessRequestsListResponse>(
			`${environment.api.baseUrl}/v1/admin/access-requests`
		);
	}

	approve(userId: string): Observable<{ ok: boolean }> {
		return this.http.post<{ ok: boolean }>(
			`${environment.api.baseUrl}/v1/admin/access-requests/${userId}/approve`,
			null
		);
	}

	deny(userId: string): Observable<{ ok: boolean }> {
		return this.http.post<{ ok: boolean }>(
			`${environment.api.baseUrl}/v1/admin/access-requests/${userId}/deny`,
			null
		);
	}
}
